import { put, call, takeLatest } from "redux-saga/effects";
import * as apis from "../../network/apis/businessVerification";
import * as types from "./types";
import * as actions from "./actions";
import { showErrorMsg, showSuccessMsg } from "../../utils/Helpers";
import { VERIFICATION_METHODS } from "../../utils/Constants";

function* verificationRequestsListSaga({ payload }) {
  try {
    const response = yield call(
      apis.verificationRequestsList,
      payload
    );
    const { Items, CurrentPage, ItemCount, TotalPages } =
      response.data.Data;
    yield put(
      actions.getVerificationsRequestsListResponse({
        list: Items,
        meta: {
          currentPage: +CurrentPage,
          count: +ItemCount,
          pages: +TotalPages
        }
      })
    );
    if (CurrentPage && TotalPages && +CurrentPage > +TotalPages) {
      yield put(
        actions.getVerificationsRequestsListRequest({
          ...payload,
          page: +TotalPages
        })
      );
    }
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* offPlatformVerificationRequestDetailsSaga({ payload }) {
  try {
    const response = yield call(
      apis.offPlatformVerificationRequestDetails,
      payload
    );
    yield put(
      actions.getOffPlatformVerificationsRequestDetailsResponse(
        response.data.Data
      )
    );
    const {
      CompanyName,
      BusinessTypeName,
      CountryName,
      RequestStatusId,
      Id
    } = response.data.Data;
    yield put(
      actions.getVerificationsRequestMainInfo({
        Id,
        CompanyName,
        BusinessTypeName,
        CountryName,
        RequestStatusId
      })
    );
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* onlinePaymentVerificationRequestDetailsSaga({ payload }) {
  try {
    const response = yield call(
      apis.onlinePaymentVerificationRequestDetails,
      payload
    );
    yield put(
      actions.getOnlinePaymentVerificationsRequestDetailsResponse(
        response.data.Data
      )
    );
    const {
      CompanyName,
      BusinessTypeName,
      CountryName,
      RequestStatusId,
      Id
    } = response.data.Data;
    yield put(
      actions.getVerificationsRequestMainInfo({
        Id,
        CompanyName,
        BusinessTypeName,
        CountryName,
        RequestStatusId
      })
    );
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* bankTransferVerificationRequestDetailsSaga({ payload }) {
  try {
    const response = yield call(
      apis.bankTransferVerificationRequestDetails,
      payload
    );
    yield put(
      actions.getBankTransferVerificationsRequestDetailsResponse(
        response.data.Data
      )
    );
    const {
      CompanyName,
      BusinessTypeName,
      CountryName,
      RequestStatusId,
      Id
    } = response.data.Data;
    yield put(
      actions.getVerificationsRequestMainInfo({
        Id,
        CompanyName,
        BusinessTypeName,
        CountryName,
        RequestStatusId
      })
    );
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* sendRequiredVerificaitonDocumentsSaga({ payload }) {
  try {
    yield call(
      apis.sendRequiredVerificationDocuments,
      payload.documents
    );
    yield showSuccessMsg("offplatformDocumentsSentSuccessfully");
    yield put(
      actions.getOffPlatformVerificationsRequestDetailsRequest({
        id: payload.id
      })
    );
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* approveOffPlatformDocsSaga({ payload }) {
  try {
    yield call(apis.approveOffPlatformDocs, payload);
    yield showSuccessMsg("offplatformDocumentsApprovedSuccessfully");
    yield put(
      actions.getOffPlatformVerificationsRequestDetailsRequest({
        id: payload.Id
      })
    );
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* requestEditOffPlatformDocsSaga({ payload }) {
  try {
    yield call(apis.requestEditOffPlatformDocs, payload);
    yield showSuccessMsg("offplatformEditDocumentsSentSuccessfully");
    yield put(
      actions.getOffPlatformVerificationsRequestDetailsRequest({
        id: payload.Id
      })
    );
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* approveVerificationRequestSaga({ payload }) {
  try {
    yield call(apis.approveVerificationRequest, payload.data);
    yield showSuccessMsg("verificationRequestAcceptedSuccessfully");
    const requestDetailsPayload = { id: payload.data.Id };
    yield put(
      payload.requestType === VERIFICATION_METHODS.onlinePayment
        ? actions.getOnlinePaymentVerificationsRequestDetailsRequest(
            requestDetailsPayload
          )
        : payload.requestType === VERIFICATION_METHODS.bankTransfer
          ? actions.getBankTransferVerificationsRequestDetailsRequest(
              requestDetailsPayload
            )
          : actions.getOffPlatformVerificationsRequestDetailsRequest(
              requestDetailsPayload
            )
    );
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* rejectVerificationRequestSaga({ payload }) {
  try {
    yield call(apis.rejectVerificationRequest, payload.data);
    yield showSuccessMsg("verificationRequestRejectedSuccessfully");
    const requestDetailsPayload = { id: payload.data.Id };
    yield put(
      payload.requestType === VERIFICATION_METHODS.onlinePayment
        ? actions.getOnlinePaymentVerificationsRequestDetailsRequest(
            requestDetailsPayload
          )
        : payload.requestType === VERIFICATION_METHODS.bankTransfer
          ? actions.getBankTransferVerificationsRequestDetailsRequest(
              requestDetailsPayload
            )
          : actions.getOffPlatformVerificationsRequestDetailsRequest(
              requestDetailsPayload
            )
    );
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

export default function* BusinessVerificationSagas() {
  yield takeLatest(
    types.GET_VERIFICATIONS_REQUESTS_LIST_REQUEST,
    verificationRequestsListSaga
  );
  yield takeLatest(
    types.GET_OFFPLATFORM_VERIFICATION_REQUEST_DETAILS_REQUEST,
    offPlatformVerificationRequestDetailsSaga
  );
  yield takeLatest(
    types.GET_ONLINE_PAYMENT_VERIFICATION_REQUEST_DETAILS_REQUEST,
    onlinePaymentVerificationRequestDetailsSaga
  );
  yield takeLatest(
    types.GET_BANK_TRANSFER_VERIFICATION_REQUEST_DETAILS_REQUEST,
    bankTransferVerificationRequestDetailsSaga
  );
  yield takeLatest(
    types.SEND_REQUIRED_VERIFICATION_DOCUMENTS_REQUEST,
    sendRequiredVerificaitonDocumentsSaga
  );
  yield takeLatest(
    types.APPROVE_OFF_PLATFORM_DOCS,
    approveOffPlatformDocsSaga
  );
  yield takeLatest(
    types.REQUEST_EDIT_OFF_PLATFORM_DOCS,
    requestEditOffPlatformDocsSaga
  );
  yield takeLatest(
    types.APPROVE_VERIFICATION_REQUEST,
    approveVerificationRequestSaga
  );
  yield takeLatest(
    types.REJECT_VERIFICATION_REQUEST,
    rejectVerificationRequestSaga
  );
}
